import React, { useEffect, useRef, useState } from "react";
import style from "./qualityReportForm.module.scss";
import { Button, CheckBox, DateTimePicker, Form, MultiSelect, Organizational } from "../../primary";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { subDays } from "date-fns";
import { convertnewDateToDate, getDateValue, getFacilityLabel } from "../../../utils";
import { getQualityAssuranceCountData, getQualityAssuranceOverViewData, setQualityReportPayload } from "../../../app/woundReportSlice";
import { optionTypeAsync } from "../../../app/patientSlice";
import { getFaciltiestCustomerAsyn } from "../../../app/usageAnalyticsReportSlice";
import useFacilityOptions from "../../../hooks/useFacilityOptions";

export const QualityReportSearchForm = ({ selectedDivOption, setSelectedDivOption, woundProgressValue, setWoundProgressValue, setTempPayload, setTabIndex }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, control, errors, reset } = useForm();

  const qualityReportPayload = useSelector((state) => state.woundreport.qualityReportPayload);
  const getFacilities = useSelector((state) => state.usageAnalyticsReport.customerFacilities);
  const woundTypeData = useSelector((state) => state.patient.woundType);
  const userDetails = useSelector((state) => state.user);

  const [firstTime, setFirstTime] = useState(true);
  const [startDate, setStartDate] = useState(new Date());
  const [toDateRes, setToDateRes] = useState("");
  const [showApplyState, setShowApplyState] = useState(false);
  const [resetFacility, setResetFacility] = useState(false);
  const [orgError, setOrgError] = useState(false);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [onselectOrgz, setOnselectOrg] = useState([]);
  const [selectedWoundValue, setSelectedWoundValue] = useState(qualityReportPayload?.woundType ?? []);

  const dateRangeRef1 = useRef(null);
  const dateRangeRef2 = useRef(null);
  const woundTypeRef = useRef(null);

  const facilities = getFacilities?.data?.facilities ?? [];
  const optionData = useFacilityOptions(facilities);

  useEffect(() => {
    dispatch(optionTypeAsync("insurancepayer"));
    dispatch(optionTypeAsync("woundType"));
  }, []);

  useEffect(() => {
    setTempPayload("");
    dispatch(getFaciltiestCustomerAsyn(qualityReportPayload?.tempWoundCustomer ?? userDetails?.customerNumber));
    const wountCountPayload = {
      ...qualityReportPayload,
      section: "Image Capture",
      subsection: "Taken Timely",
    };
    dispatch(setQualityReportPayload(wountCountPayload));
  }, []);

  const pageOnloadAPI = () => {
    let facilitykey = [];
    optionData &&
      Array.isArray(optionData) &&
      optionData.map((item) => {
        //NOSONAR
        let facility = item.key.split("|")[0].trim();
        facilitykey = [...facilitykey, facility];
      }); //NOSONAR
    const payload = {
      fromDate: convertnewDateToDate(new Date(document.getElementById("datePicker1").value)),
      toDate: convertnewDateToDate(new Date(document.getElementById("datePicker2").value)),
      facility: facilitykey,
      woundType: "",
      payor: "",
      isDischargedPatient: 0,
      section: "Image Capture",
      subsection: "Taken Timely",
    };
    if (optionData.length > 0) {
      if (qualityReportPayload && qualityReportPayload?.facility && qualityReportPayload?.facility.length !== 0) {
        dispatch(getQualityAssuranceOverViewData(qualityReportPayload));
        setTempPayload(qualityReportPayload);
        let wountCountPayload = {
          ...qualityReportPayload,
          section: qualityReportPayload.section,
        };
        dispatch(getQualityAssuranceCountData(wountCountPayload));
        setShowApplyState(true);
      } else {
        dispatch(getQualityAssuranceOverViewData(payload));
        setTempPayload(payload);
        let wountCountPayload = { ...payload, section: selectedDivOption };
        dispatch(getQualityAssuranceCountData(wountCountPayload));
        dispatch(setQualityReportPayload({ ...wountCountPayload, section: "Image Capture", subsection: "Taken Timely", onselectOrgz: onselectOrgz }));
      }
      if (document.getElementById("datePicker1").value) {
        setToDateRes(new Date(document.getElementById("datePicker1").value));
      }
    }
  };

  useEffect(() => {
    if (firstTime && getFacilities?.data?.facilities.length > 0 && document.getElementById("datePicker1") && document.getElementById("datePicker2")) {
      setFirstTime(false);
      pageOnloadAPI();
    }
  }, [firstTime, getFacilities]);

  const customFromDatePickerChange = (e) => {
    const fromDates = new Date(e).getTime();
    const toDates = new Date(document.getElementById("datePicker2").value).getTime();
    setToDateRes(new Date(e));
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
      }
    }, 500);
    setShowApplyState(true);
  };
  const handleOnBlurFrom = ({ target: { value } }) => {
    const fromDates = new Date(value).getTime();
    const toDates = new Date(document.getElementById("datePicker2").value).getTime();
    setToDateRes(new Date(value));
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
      }
    }, 500);
  };
  const handleOnBlurTO = ({ target: { value } }) => {
    const fromDates = new Date(document.getElementById("datePicker1").value).getTime();
    const toDates = new Date(value).getTime();
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
        setToDateRes("");
      }
    }, 500);
  };
  const customToDatePickerChange = (e) => {
    setShowApplyState(true);
    const fromDates = new Date(document.getElementById("datePicker1").value).getTime();
    const toDates = new Date(e).getTime();
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker1").value = "";
        setToDateRes("");
      }
    }, 500);
  };

  const onSelectOrg = (selectedList) => {
    if (optionData && selectedList && optionData?.length !== selectedList?.length) {
      setShowApplyState(true);
    }
    if (setSelectedFacilities) {
      setOrgError(false);
      let facilitykey = [];
      selectedList &&
        Array.isArray(selectedList) &&
        selectedList.map((item) => {
          //NOSONAR
          let facility = item.key.split("|")[0].trim();
          facilitykey = [...facilitykey, facility];
        }); //NOSONAR
      setSelectedFacilities(facilitykey);
    }
    if (selectedList.length === 0) {
      setOnselectOrg([]);
    } else {
      setOnselectOrg([...selectedList]);
    }
  };

  const onSubmit = (data) => {
    // setErrorMsg("");
    if (selectedFacilities.length === 0) {
      setOrgError(true);

      // if (selectedFacilities.length >0) {
      // dispatch(getQualityAssuranceOverViewData());
      // dispatch(getWoundDashBoardWoundcount());}
    } else {
      setOrgError(false);
    }
    // setSubmitState(true);
    let payload = {
      fromDate: convertnewDateToDate(data.datePicker1),
      toDate: convertnewDateToDate(data.datePicker2),
      facility: selectedFacilities,
      woundType: selectedWoundValue,
      // payor: data.payorType,
      isDischargedPatient: data.isDischargedPatient === "Include Discharged Patients" ? 1 : 0,
      onselectOrgz: onselectOrgz,
    };
    const fromDates = new Date(document.getElementById("datePicker1").value).getTime();
    const toDates = new Date(document.getElementById("datePicker2").value).getTime();
    setToDateRes(new Date(document.getElementById("datePicker1").value));
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
      } else {
        if (selectedFacilities.length > 0) {
          dispatch(getQualityAssuranceOverViewData(payload));
          // let wountCountPayload = { ...payload, section: selectedDivOption}
          let wountCountPayload = {
            ...payload,
            section: selectedDivOption,
            subsection: woundProgressValue,
            onselectOrgz: onselectOrgz,
          };
          //setSelectedDivOption("Image Capture")
          //setWoundProgressValue
          setTempPayload(wountCountPayload);
          dispatch(getQualityAssuranceCountData(wountCountPayload));

          let tempWoundPayload = wountCountPayload;
          if (document.getElementById("customerNumber")?.value) {
            tempWoundPayload = {
              ...tempWoundPayload,
              tempWoundCustomer: document.getElementById("customerNumber").value,
            };
          }
          dispatch(setQualityReportPayload(tempWoundPayload));
        }
      }
    }, 10);
  };

  const handleWoundChange = (e) => {
    setShowApplyState(true);
    const keys = Array.isArray(e) ? e.filter((item) => item.key !== "").map((item) => item.key) : [];
    setSelectedWoundValue(keys);
  };

  const resetData = () => {
    setOnselectOrg([]);
    // dispatch(setCustomerFacilities({}));
    dispatch(setQualityReportPayload({}));
    reset({ woundType: "", payorType: "", isDischargedPatient: "" });
    woundTypeRef.current.resetSelectedValues([]);
    setSelectedWoundValue("");
    setShowApplyState(true);
    // setSubmitState(false);
    setResetFacility(true);
    setSelectedDivOption("Image Capture");
    setWoundProgressValue("Taken Timely");
    setTabIndex(0);
    // dispatch(getFaciltiestCustomerAsyn(userDetails?.customerNumber));
    setTimeout(() => {
      setFirstTime(true);
    }, 500);
  };

  return (
    <Form className={style.wound_form} onSubmit={handleSubmit(onSubmit)}>
      <div className={`col-8 ${style.col_spec}`}>
        <label className={`col-5 ${style.label_spec}`}>Date Range:</label>
        <DateTimePicker
          id={"datePicker1"}
          name={"datePicker1"}
          control={control}
          classes={{
            date_picker: style.wound_input,
            dateColumn: "col-12 p-0",
            column: `col m-0 ${style.col_spec}`,
          }}
          selected={startDate}
          customOnChange={customFromDatePickerChange}
          defaultValue={
            qualityReportPayload && qualityReportPayload.fromDate
              ? new Date(qualityReportPayload.fromDate)
              : subDays(new Date(startDate), 30)
          }
          displayIcon={true}
          validator={register()}
          showMonthDropdown={true}
          showYearDropdown={true}
          dateRef={dateRangeRef1}
          errors={errors}
          maxDate={new Date()}
          onBlur={handleOnBlurFrom}
        />
        <DateTimePicker
          id={"datePicker2"}
          name={"datePicker2"}
          control={control}
          classes={{
            date_picker: style.wound_input,
            dateColumn: "col-12 p-0",
            column: `col m-0 pr-0 ${style.col_spec}`,
          }}
          defaultValue={qualityReportPayload && qualityReportPayload.toDate ? new Date(qualityReportPayload.toDate) : new Date()}
          customOnChange={customToDatePickerChange}
          displayIcon={true}
          validator={register()}
          showMonthDropdown={true}
          showYearDropdown={true}
          dateRef={dateRangeRef2}
          minDate={toDateRes ? toDateRes : ""}
          maxDate={new Date()}
          errors={errors}
          onBlur={handleOnBlurTO}
        />
      </div>
      <div className={`col-4 ${style.col_spec}`}></div>

      {optionData && Array.isArray(optionData) && optionData.length === 0 && (
        <Organizational
          id={"facility"}
          name={"facility"}
          label={`Facility/Location:`}
          classes={{
            column: `col-8 ${style.col_spec}`,
            inputClassName: style.wound_select,
            labelClassName: `col-5 ${style.label_spec}`,
            inputColumn: `col-7 p-0`,
          }}
          optionValue={optionData}
          groupBy="cat"
          displayValue="key"
          onSelect={(val) => onSelectOrg(val)}
          selectAll={true}
          resetDefault={resetFacility}
          reportView={true}
          customError={orgError}
          required={true}
          defaultValue={Array.isArray(onselectOrgz) && onselectOrgz.length > 0 ? onselectOrgz : optionData}
        />
      )}
      {optionData && Array.isArray(optionData) && optionData.length !== 0 && (
        <Organizational
          id={"facility"}
          name={"facility"}
          label={`Facility/Location:`}
          classes={{
            column: `col-8 ${style.col_spec}`,
            inputClassName: style.wound_select,
            labelClassName: `col-5 ${style.label_spec}`,
            inputColumn: `col-7 p-0`,
          }}
          optionValue={optionData}
          groupBy="cat"
          displayValue="key"
          defaultValue={
            qualityReportPayload && qualityReportPayload.onselectOrgz
              ? qualityReportPayload.onselectOrgz
              : Array.isArray(onselectOrgz) && onselectOrgz.length > 0
              ? onselectOrgz
              : optionData
          }
          onSelect={(val) => onSelectOrg(val)}
          selectAll={true}
          resetDefault={resetFacility}
          reportView={true}
          customError={orgError}
          required={true}
        />
      )}

      <div className={`col-4 ${style.col_spec}`}></div>
      <MultiSelect
        id={"woundType"}
        name={"woundType"}
        label={"Wound Types:"}
        classes={{
          column: `col-8 ${style.col_spec}`,
          inputClassName: style.wound_select,
          labelClassName: `col-5 ${style.label_spec}`,
          inputColumn: `col-7 p-0 ${style.select_wrapper}`,
        }}
        optionValue={woundTypeData}
        validator={(e) => {
          register({ required: true });
          woundTypeRef.current = e;
        }}
        placeholder="Select"
        showCheckbox={true}
        displayValue="value"
        onSelect={handleWoundChange}
        onRemove={handleWoundChange}
        labelSubText={"Select all that apply"}
        defaultValue={qualityReportPayload && qualityReportPayload.woundType ? qualityReportPayload.woundType : []}
      />

      <div className={`col-4 ${style.col_spec}`}></div>
      {showApplyState && (
        <div className={`col-8 ${style.col_spec}`}>
          <label className={`col-5 ${style.label_spec}`}></label>
          <Button
            classes={{
              className: `btn ${style.btn_custom} ${style.btn_small} mr-4`,
            }}
            type="submit"
          >
            Apply
          </Button>
          <Button
            classes={{
              className: `btn ${style.btn_custom} ${style.btn_small_cancel} `,
            }}
            onClick={resetData}
            type={"button"}
          >
            Reset
          </Button>
        </div>
      )}
    </Form>
  );
};
